/**
 * The game names a screenshot `WoWScrnShot_MMDDYY_HHMMSS.<ext>` in local time. The addon's
 * button records the stem from its own clock, which can be a second behind the game's name for
 * the file, so a file belongs to a recorded stem when the two are within 2 seconds.
 */
export const STEM_TOLERANCE_SECONDS = 2;
const STEM = /^WoWScrnShot_(\d{2})(\d{2})(\d{2})_(\d{2})(\d{2})(\d{2})$/;
const UPLOADABLE = /\.(jpe?g|png)$/i;

/** The stem as a naive date-time in seconds (no timezone: only differences mean anything); null if it is not one. */
export function stemSeconds(stem: string): number | null {
  const m = STEM.exec(stem);
  if (!m) return null;
  const [mo, d, y, h, mi, s] = m.slice(1).map(Number) as [number, number, number, number, number, number];
  if (mo < 1 || mo > 12 || d < 1 || d > 31 || h > 23 || mi > 59 || s > 59) return null;
  return Date.UTC(2000 + y, mo - 1, d, h, mi, s) / 1000;
}

/** Whether `fileName` is an uploadable screenshot taken within the tolerance of `stem`. */
export function matchesStem(fileName: string, stem: string): boolean {
  const ext = UPLOADABLE.exec(fileName);
  if (!ext) return false;
  const file = stemSeconds(fileName.slice(0, ext.index));
  const want = stemSeconds(stem);
  return file !== null && want !== null && Math.abs(file - want) <= STEM_TOLERANCE_SECONDS;
}
